import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import config from '../config';
import navigation from '../menu-items';

// Generaliza a lógica de match rota->menu já usada (só localmente) em
// `Breadcrumbs.js::getCollapse` - mesma varredura recursiva de
// `navigation.items` (grupos -> collapse/item), mas via `useLocation()`
// (reage a navegação client-side) em vez de `document.location.pathname`
// (só lido no mount/re-render, não muda sozinho quando a rota muda sem
// reload de página). Usado pelo painel do Assistente IA pra saber em que
// módulo/página o usuário está agora, sem precisar de estado global novo.
const findMatch = (items, pathname) => {
    for (const group of items) {
        if (group.type !== 'group' || !group.children) continue;

        const stack = [...group.children];
        while (stack.length) {
            const entry = stack.pop();
            if (entry.type === 'collapse' && entry.children) {
                stack.push(...entry.children);
            } else if (entry.type === 'item' && config.basename + entry.url === pathname) {
                return { module: group.title || group.id, page: entry.title };
            }
        }
    }
    return null;
};

export default function useCurrentModule() {
    const location = useLocation();

    return useMemo(() => {
        const match = findMatch(navigation.items, location.pathname);
        return {
            module: match?.module || null,
            page: match?.page || null,
            route: location.pathname,
        };
    }, [location.pathname]);
}
